import type { CSSProperties } from 'react';
import type { ArtPiece } from '../art/art';

/** One of the mockup's illustrations (mountains, river, houses, night sky), drawn exactly as the owner's file draws it. */
export function Art({ piece, top = 0, style }: { piece: ArtPiece; top?: number; style?: CSSProperties }) {
  return (
    <svg
      aria-hidden="true"
      width={390}
      height={piece.height}
      viewBox={piece.viewBox}
      style={{ position: 'absolute', left: 0, top, display: 'block', pointerEvents: 'none', ...style }}
      dangerouslySetInnerHTML={{ __html: piece.inner }}
    />
  );
}
